import type { Equipped } from '@cratered/shared';
import { ugcUrl } from '../ugc';
import type { MoleLook } from './mole';

/** What to draw for a player's equipped cosmetics, custom art included. */
export function lookFor(equipped: Equipped, teamColor: string): MoleLook {
  return {
    body: equipped.body,
    outfit: equipped.outfit,
    teamColor,
    customBody: equipped.custom?.body ? ugcUrl(equipped.custom.body) : undefined,
    customHead: equipped.custom?.head ? ugcUrl(equipped.custom.head) : undefined,
  };
}
